import browserHistory from '~/browserHistory';
import { ModalOrder, useModal } from '~/components/ModalQueue';
import { TnCOffices } from '~/constants/ff.posthog';
import {
  OfficeTnCTypeEnum,
  useAcceptOfficeConsentContent,
  useGetOfficeConsentContent,
} from '~/domain/Consents';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { useUserSelector } from '~/hooks/useUserSelector';
import { routes } from '~/routes';

export const useOfficeTnCConsent = () => {
  const user = useUserSelector();
  const pathname = browserHistory.location.pathname
  const officeId = user?.id ?? '';
  const isFeatureEnabled = useFeatureFlag(TnCOffices);
  const isOnTnCPage = pathname === routes.termsAndConditions;

  const { data: consentContent, isLoading, refetch } = useGetOfficeConsentContent({
    params: {
      officeId,
      code: OfficeTnCTypeEnum.OFFICE_TNC,
    },
    enabled: isFeatureEnabled && !!officeId,
  });

  const shouldShow =
    isFeatureEnabled &&
    !isOnTnCPage &&
    !isLoading &&
    !!consentContent &&
    (!consentContent.isConsented || consentContent.notConsentedRequirements.length > 0);

  const { isActive } = useModal({
    id: ModalOrder.OFFICE_TNC_CONSENT_POPUP,
    condition: shouldShow,
  });

  const acceptMutation = useAcceptOfficeConsentContent({
    onSuccess: () => {
      refetch();
      browserHistory.push(routes.dashboardHome)
    },
  });

  const handleAccept = () => {
    acceptMutation.mutate({
      officeId,
      code: OfficeTnCTypeEnum.OFFICE_TNC,
    });
  };

  const pdfUrl = consentContent?.notConsentedRequirements?.[0]?.url;


  return {
    isActive,
    shouldShow,
    consentContent,
    handleAccept,
    isAccepting: acceptMutation.isPending,
    pdfUrl,
    isLoading
  };
};
